import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { PropertyProvider } from "./context/PropertyContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import PropertyPage from "./pages/PropertyPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { initAnalytics, trackPageView } from "./lib/analytics";

const AnalyticsListener = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Shell = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-[#0A0F16]">
      <div className="grain-overlay" />
      <Header />
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ContentProvider>
              <PropertyProvider>
                <AnalyticsListener />
                <ScrollToTop />
                <Shell>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/propiedad/:slug" element={<PropertyPage />} />
                    <Route path="/property/:slug" element={<PropertyPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                  </Routes>
                </Shell>
                <Toaster theme="dark" position="top-right" toastOptions={{
                  style: { background: "#111822", border: "1px solid rgba(197,160,89,0.3)", color: "#fff" }
                }} />
              </PropertyProvider>
            </ContentProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
